export const LineOfBusinessesBrandingColors = {
    S4A: {
        headerBackgroundColor: '#3629ed',
        headerColor: '#fff',
        fabBackgroundColor: '#3629ed',
        fabColor: '#fff',
        messageIconColor: '#3629ed',
        primaryMessageBubbleBackgroundColor: '#3629ed',
        buttonHoverColor: '#3629ed',
    },
    S4A_STAGING: {
        headerBackgroundColor: '#3629ed',
        headerColor: '#fff',
        fabBackgroundColor: '#3629ed',
        fabColor: '#fff',
        messageIconColor: '#3629ed',
        primaryMessageBubbleBackgroundColor: '#3629ed',
        buttonHoverColor: '#3629ed',
    },
    S4P: {
        headerBackgroundColor: '#9691FF',
        headerColor: '#220287',
        fabBackgroundColor: '#9691FF',
        fabColor: '#220287',
        messageIconColor: '#9691FF',
        primaryMessageBubbleBackgroundColor: '#220287',
        buttonHoverColor: '#220287',
    },
    S4P_STAGING: {
        headerBackgroundColor: '#9691FF',
        headerColor: '#220287',
        fabBackgroundColor: '#9691FF',
        fabColor: '#220287',
        messageIconColor: '#9691FF',
        primaryMessageBubbleBackgroundColor: '#220287',
        buttonHoverColor: '#220287',
    },
    CONSUMER: {
        headerBackgroundColor: '#21D05F',
        headerColor: '#fff',
        fabBackgroundColor: '#21D05F',
        fabColor: '#fff',
        messageIconColor: '#25C95E',
        primaryMessageBubbleBackgroundColor: '#25C95E',
        buttonHoverColor: '#21D05F',
    },
    CONSUMER_STAGING: {
        headerBackgroundColor: '#21D05F',
        headerColor: '#fff',
        fabBackgroundColor: '#21D05F',
        fabColor: '#fff',
        messageIconColor: '#25C95E',
        primaryMessageBubbleBackgroundColor: '#25C95E',
        buttonHoverColor: '#21D05F',
    },
};
//# sourceMappingURL=lineOfBusinessesBrandingColors.js.map